var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4 20C36.5856 17.6892 34.4479 16.1057 32 16H24C20.6863 16 18 18.6863 18 22C18 25.3137 20.6863 28 24 28H32C35.3137 28 38 30.6863 38 34C38 37.3137 35.3137 40 32 40H24C21.5521 39.8943 19.4144 38.3108 18.6 36",
    stroke: "#00B3B5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 10C28.875 9.51675 28.4832 9.125 28 9.125C27.5168 9.125 27.125 9.51675 27.125 10H28H28.875ZM27.125 16C27.125 16.4832 27.5168 16.875 28 16.875C28.4832 16.875 28.875 16.4832 28.875 16H28H27.125ZM28.875 40C28.875 39.5168 28.4832 39.125 28 39.125C27.5168 39.125 27.125 39.5168 27.125 40H28H28.875ZM27.125 46C27.125 46.4832 27.5168 46.875 28 46.875C28.4832 46.875 28.875 46.4832 28.875 46H28H27.125ZM28 10H27.125V16H28H28.875V10H28ZM28 40H27.125V46H28H28.875V40H28Z",
    fill: "#00B3B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.8be776d94f7078d19d4080db52254126.svg";
export { ForwardRef as ReactComponent };